<template>
  <div class="columns is-centered">
    <div class="column is-4">
      <div class="card">
        <div class="card-content">
          Are you sure ou want to delete this request?
        </div>
        <div class="card-footer">
          <a class="card-footer-item" @click="onCancelClicked">Cancel</a
          ><a class="card-footer-item has-text-danger" @click="onDeleteClicked"
            >Delete</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    onCancelClicked() {
      let component = this;
      component.$router.go(-1);
    },
    onDeleteClicked() {
      let component = this;
      component.$store
        .dispatch("leave/delete", component.$route.params.id)
        .then(() => {
          component.$router.push("/request/leave");
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  width: 400px;
  border: 1px solid $grey-lighter;
  margin: auto;
}
</style>
